





















declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...

import { Component, Prop, Vue } from 'vue-property-decorator';
import {ToggleButton} from 'vue-js-toggle-button'
import {Vendor} from '@iabtcf/core'

@Component({
  components: {
    ToggleButton,
  },
})

export default class NonTCFVendorItem extends Vue {

    consent = false;
    collapsed = true;
    collapseClass = "collapseButton collapseButtonRotatedUp"

    @Prop( { default:{ name:'none'} }) vendor!: Vendor;

    mounted() : void {

      for ( let modelVendor  in gGDPR_NonTCFVendors) {
      // @ts-ignore
        if ( gGDPR_NonTCFVendors[modelVendor].id == this.vendor.id ) {
        // @ts-ignore
          this.consent = gGDPR_NonTCFVendors[modelVendor].modelConsent;
        }
      }

      // TODO: Make sure code above sets initial value when recovering consent (set modelConsent = consent somewhere...)

    }

    changeConsent( value: object, srcEvent: any ) {

      // @ts-ignore
      let model = window.__cmpTCModel;

    // @ts-ignore
      if ( value.value )
        model.vendorConsents.set( this.vendor.id );
      else
        model.vendorConsents.unset( this.vendor.id );

    // @ts-ignore
      this.consent = value.value;

      // TODO: Emit dirty event here to enable button/save
      this.$emit('modelChangeEvent', true );

      for ( let modelVendor  in gGDPR_NonTCFVendors) {
      // @ts-ignore
        if ( gGDPR_NonTCFVendors[modelVendor].id == this.vendor.id ) {
        // @ts-ignore
          gGDPR_NonTCFVendors[modelVendor].modelConsent = this.consent;
        }
      }
    // @ts-ignore
      this.consent = value.value;


      // TODO: Emit dirty event here to enable button/save
      this.$emit('modelChangeEvent', true );

    }


    expandCollapseClick() {
      if ( this.collapsed )
        this.collapseClass = 'collapseButton collapseButtonRotatedDown';
      else
        this.collapseClass = 'collapseButton collapseButtonRotatedUp';
      this.collapsed = ! this.collapsed;
    }

}

